import {Heading, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {BrakeFluidReplacementGroup} from '../../kit/groups/BrakeFluidReplacementGroup';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function BrakeFluidReplacementSubSection() {
  return (
    <>
      <VFKit.SubSection data-testid="brake-fluid-replacement">
        <VStack spacing={4}>
          <Heading size={4}>{i18n.t('entity.vehicle.labels.brakeFluid')}</Heading>
          <VFKit.Group columns={4} data-testid="brake-fluid-replacement-group">
            <BrakeFluidReplacementGroup />
          </VFKit.Group>
        </VStack>
      </VFKit.SubSection>
    </>
  );
}
